import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
// TODO Move this somewhere else; CorePackage?
import { defineCommand } from '../../concepts/commands/CommandDefinition';
import { stringStep } from '../../concepts/commands/CommandWizard';
import { Communicator } from '../../concepts/objects';
import { FeedbackPopup } from '../help/FeedbackPopup';
import { alert } from '../packages/alerts/AlertCommands';
import { optionsPopupWith } from '../popups/OptionsPopup';
import { PopupManager } from '../popups/PopupManager';
import { BoardInfo } from './BoardInfo';
import { EditorSession } from './EditorSession';
import { Phys } from './entities/Phys';
import { RelativeTo } from './entities/Physical';
import { Selection } from './Selection';

export const setBoardName = defineCommand(
    'setBoardName',
    'Board: Rename...',
    (r, [name]: [string]) => {

        const session = r.call(EditorSession);
        const api = r.call(ApiClient);
        const comms = r.call(Communicator);

        const boardInfo = session.get(BoardInfo);

        api.exec(v2.boards.patch(boardInfo.id, { name }));
        session.patch(BoardInfo, { name, label: name });
        comms.send('boardName', { name, label: name });

    },
    [
        stringStep('name', 'Enter the new name:'),
    ]
);

export const giveFeedback = defineCommand(
    'giveFeedback',
    'Give Feedback',
    async cc => {
        const popups = cc.resolve(PopupManager);
        const { actioned, data } = await popups.invoke({ ui: FeedbackPopup });
        if (actioned && data) {
            await popups.invoke(optionsPopupWith(
                'Thank you!',
                'We appreciate your help making Ludi better!',
                [[true, 'Close', 'common', 'confirm']]
            ));
        }
    },
);

export const hoist = defineCommand(
    'hoist',
    'Hoist',
    async (cc) => {

        const api = cc.resolve(ApiClient);
        const session = cc.resolve(EditorSession);

        const selection = session.get(Selection);
        if (!selection.size) return;

        const boardInfo = session.get(BoardInfo);
        const objects = Phys.from(selection)
            .takeHeads()
            .map(x => ({
                id: x.id,
                type: x.type,
                data: x.toTuple(RelativeTo.Model),
            }));

        await api.exec(v2.boards.objects.hoist({
            boardId: boardInfo.id,
            objects,
        }));

        cc.dispatch(alert, [`Hoisted ${objects.length} objects`]);
    },
);
